import { render, staticRenderFns } from "./attr.vue?vue&type=template&id=578f7fb6&"
import script from "./attr.vue?vue&type=script&lang=js&"
export * from "./attr.vue?vue&type=script&lang=js&"
import style0 from "./attr.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports